import { LogsActionTypes } from "./constants";

const INIT_STATE = {
  list: [],
  total: 0,
  one: null,
  loading: false,
};

interface LogsData {
  items?: any[];
  total?: number;
}

interface GetLogData {
  id: string;
}

interface LogsActionType {
  type:
    | LogsActionTypes.GET_LIST_LOGS
    | LogsActionTypes.GET_LIST_LOGS_ERROR
    | LogsActionTypes.GET_LIST_LOGS_SUCCESS
    | LogsActionTypes.GET_LOG
    | LogsActionTypes.GET_LOG_SUCCESS
    | LogsActionTypes.GET_LOG_ERROR;
  payload: {
    actionType?: string;
    data?: LogsData;
    getLog?: GetLogData;
    error?: string;
  };
}

interface State {
  list?: any[];
  total?: number;
  one?: any;
  loading?: boolean;
}

const Logs = (state: State = INIT_STATE, action: LogsActionType): any => {
  switch (action.type) {
    case LogsActionTypes.GET_LOG:
      return {
        ...state,
        list: [],
        one: null,
        loading: true,
        error: "",
        total: 0,
      };

    case LogsActionTypes.GET_LOG_SUCCESS:
      switch (action.payload.actionType) {
        case LogsActionTypes.GET_LOG: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: action.payload.data,
            error: "",
          };
        }
        default:
          return { ...state };
      }

    case LogsActionTypes.GET_LOG_ERROR:
      switch (action.payload.actionType) {
        case LogsActionTypes.GET_LOG: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: null,
            error: action.payload.error,
          };
        }
        default:
          return { ...state };
      }

    case LogsActionTypes.GET_LIST_LOGS_SUCCESS:
      switch (action.payload.actionType) {
        case LogsActionTypes.GET_LIST_LOGS: {
          return {
            ...state,
            list: action.payload.data.items,
            loading: false,
            total: action.payload.data.total,
            one: null,
            error: "",
          };
        }
        default:
          return { ...state };
      }

    case LogsActionTypes.GET_LIST_LOGS_ERROR:
      switch (action.payload.actionType) {
        case LogsActionTypes.GET_LIST_LOGS: {
          return {
            ...state,
            error: action.payload.error,
            list: [],
            total: 0,
            loading: false,
          };
        }
        default:
          return { ...state };
      }

    case LogsActionTypes.GET_LIST_LOGS:
      return {
        ...state,
        loading: true,
        list: [],
        total: 0,
        one: null,
        error: "",
      };

    default:
      return { ...state };
  }
};

export default Logs;
